import * as utils from "../../utils";

var privateHandler = {
	get: function(obj, prop) {
		return prop.startsWith("_") ? null : obj[prop];
	}
};

/**
 * Definition of a point to get from the live feed.
 */
export class Point {
	pointId;
	label;
	unit;
	processor; //ProcessPoints object
	chartLabel;
	currentValue;
	data;
	lastUpdate;
	includeHistory;
	seriesConfig = {
		color: null,
		yAxis: null
	};
}

export class PointDisplay {
	type;
	source;
	playbackGroup;
	historyGroup;
	points = [];
	chart;
}

export class Interval {
	constructor(_delay) {
		this.delay = 0 || _delay;
	}
	delay = 0;
	intervalId = null;
	Start(func, ...args) {
		this.intervalId = setInterval(func, this.delay, ...args);
	}
	End() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	}
}

/**
 * ProcessorRtn.
 * Use to return an altered point in a PreProcess or PostProcess function.
 * Points can be deffered and then accessed in the ProcessorArg of the the next point
 */
export class ProcessorRtn {
	_rtnsData = null;
	_defferedData = null;
	_type = "ProcessorRtn";

	/**
	 * set the points, after transformations, to be added to the main data collection
	 * @param {Point} points
	 */
	ApplyPoints(points) {
		if (Array.isArray(points)) {
			this._rtnsData = points;
		} else {
			this._rtnsData = [points];
		}
	}
	/**
	 * 	defer the data to be added to ProcessorArgs of next point
	 *	useful for combining multiple points into one set
	 * @param {Point} points
	 */
	DeferData(points) {
		if (Array.isArray(points)) {
			this._defferedData = points;
		} else {
			this._defferedData = [points];
		}
	}
}

/**
 * ProcessorArg
 * The arg object passed to a pipeline Processor function.
 */
export class ProcessorArg {
	_deferred = null;
	_point = null;
	_type = "ProcessorArg";

	/**
	 * Get any deferred objects from the previous point.
	 */
	get DeferredPoints() {
		return this._deferred;
	}

	get Point() {
		return this._point;
	}
}

/**
 * A class to apply modular transformations on Points.
 * Use child class ProcessPoints externally
 */
export class BaseProcessPoints {
	constructor(id, points) {
		this.processorId = id;
		this.dataPoints = points;
	}

	dataPoints = [];
	processorId = null;

	_RunProcess(point, modifiedPoint, deferred, func) {
		let args = new ProcessorArg();
		args._deferred = deferred;
		args._point = modifiedPoint || point;

		let rtns = func(new Proxy(args, privateHandler));

		if (rtns._type !== "ProcessorRtn") {
			throw "Processor function returned something other than ProcessorRtn";
		}

		return rtns;
	}

	_ApplyProcesses(processes) {
		let points = []; //the point data after all process funcs
		let deferred = []; //deferred data from last point

		for (let p = 0; p < this.dataPoints.length; p++) {
			let modifiedPoint = null; //rtn data for each individual process
			const iterationDeferred = deferred.slice(); //copy vals
			deferred = [];
			let rtns = null;
			for (let i = 0; i < processes.length; i++) {
				const func = processes[i];
				rtns = this._RunProcess(this.dataPoints[p], modifiedPoint, iterationDeferred, func);

				if (rtns._deferredData) {
					deferred.push(...rtns._deferredData);
				}
				if (rtns._rtnsData) {
					modifiedPoint = rtns._rtnsData;
				}
			}
			//if the last process doesnt return a modified point then it isnt added to the collection
			if (rtns._rtnsData) {
				points.push(rtns._rtnsData);
			}
		}
		this.dataPoints = points;
	}
}

/**
 * A class to apply modular transformations on Points
 */
export class ProcessPoints extends BaseProcessPoints {
	constructor(id, pointsArray) {
		super(id, pointsArray);
	}

	preProcesses = [];
	postProcesses = [];

	/**
	 * 	any number of process function to be applied to raw data.
	 *	a process function takes a ProcessorArg and returns a ProcessorRtn
	 * @param {...Funcs} funcs
	 */
	AddPreProcess(...funcs) {
		this.preProcesses.push(...funcs);
	}

	/**
	 * any number of process function to be applied to data at the end of pipeline.
	 * a process function takes a ProcessorArg and returns a ProcessorRtn
	 * @param {...Funcs} funcs
	 */
	AddPostProcess(...funcs) {
		this.postProcesses.push(...funcs);
	}

	ApplyPreProcesses() {
		return super._ApplyProcesses(this.preProcesses);
	}

	ApplyPostProcesses() {
		return super._ApplyProcesses(this.postProcesses);
	}
}



// WEBPACK FOOTER //
// ./src/services/Live/types.js